import { useEffect, useState } from "react";

import { CheckV2Icon, IndeterminateIcon } from "components/icons";

import cn from "lib/cn";

import styles from "./CheckboxV2.module.css";

export interface CheckboxV2Props {
  checked?: boolean;
  variant?: "contained";
  isIndeterminate?: boolean;
  className?: string;
  onCheck?: (checked: boolean) => void;
}

const CheckboxV2 = ({
  variant = "contained",
  checked,
  isIndeterminate = false,
  className,
  onCheck,
}: CheckboxV2Props) => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setIsChecked(!!checked);
  }, [checked]);

  const handleOnCheck = () => {
    if (checked !== undefined && onCheck) {
      return onCheck(!isChecked);
    }

    setIsChecked((prev) => !prev);
  };

  return (
    <div
      className={cn(
        "shrink-0",
        className,
        styles.container,
        styles[variant],
        isChecked || isIndeterminate ? styles[`${variant}_active`] : undefined
      )}
      onClick={handleOnCheck}
    >
      {(isChecked || isIndeterminate) && (
        <div>
          {isIndeterminate ? (
            <IndeterminateIcon viewBox="-2 -5 12 13" width={11} height={13} />
          ) : (
            <CheckV2Icon viewBox="-2 -3 15 15" width={12} height={13} />
          )}
        </div>
      )}
    </div>
  );
};

export default CheckboxV2;
